import { AREA_LABELS } from "../../shared/lead";

export const ar = {
  meta: {
    title: "واجهة قرطبة | سجّل اهتمامك بمكاتب طريق المطار",
    description:
      "مكاتب للإيجار في واجهة قرطبة على طريق المطار بالرياض. سجّل اهتمامك وسيتواصل معك فريق المشروع بالمساحات المتاحة وتفاصيل التأجير.",
    ogLocale: "ar_SA",
    htmlLang: "ar",
  },
  brand: {
    projectName: "واجهة قرطبة",
    projectCaption: "مكاتب للإيجار السنوي",
  },
  header: {
    cta: "سجّل اهتمامك",
  },
  media: {
    title: "واجهة قرطبة — صور المشروع",
    video: "فيديو المشروع",
    brochure: "البروشور",
    brochureMobile: "البروشور PDF",
    platform: "المنصة التفاعلية",
    location: "موقع المشروع",
    whatsappTitle: "تواصل مع بوند عبر واتساب",
    whatsappSubtitle: "استفسر عن المساحات المكتبية المتاحة",
  },
  form: {
    title: "سجّل اهتمامك",
    intro: "شاركنا بياناتك وسيتواصل معك فريق المشروع لتزويدك بالمساحات المتاحة وتفاصيل التأجير.",
    fullName: "الاسم الكامل",
    fullNamePlaceholder: "اكتب اسمك",
    phone: "رقم الجوال",
    phonePlaceholder: "+966",
    email: "البريد الإلكتروني",
    emailPlaceholder: "name@company.com",
    company: "اسم الشركة / الجهة",
    companyPlaceholder: "اكتب اسم الشركة أو الجهة",
    area: "المساحة المطلوبة",
    areaPlaceholder: "اختر المساحة (اختياري)",
    notes: "ملاحظات أو متطلبات خاصة",
    notesPlaceholder: "اكتب أي تفاصيل تساعدنا على فهم احتياجك",
    submit: "سجّل اهتمامك",
    privacy:
      "سيتم استخدام بياناتك للتواصل معك بخصوص تأجير المكاتب في واجهة قرطبة. نستخدم Microsoft Clarity لتحليل استخدام الموقع وتحسينه، وقد يستخدم ملفات تعريف ارتباط لهذا الغرض.",
    submitting: "جارٍ تسجيل اهتمامك...",
  },
  submitState: {
    errorHeading: "تعذر إرسال بياناتك",
    errorBody: "حدث خطأ أثناء الإرسال. يمكنك المحاولة مرة أخرى، أو التواصل معنا مباشرة.",
    retry: "إعادة المحاولة",
    finalHeading: "لم نتمكن من إرسال بياناتك",
    finalBody:
      "يرجى التواصل معنا مباشرة عبر إحدى القنوات التالية، وسنساعدك في إتمام تسجيل اهتمامك.",
    contactTitle: "تواصل معنا",
    edit: "تعديل البيانات",
  },
  social: {
    whatsapp: "واتساب",
    instagram: "إنستغرام",
    linkedin: "لينكدإن",
  },
  area: AREA_LABELS,
  errors: {
    required: "هذا الحقل مطلوب.",
    tooShort: "الاسم قصير جدًا.",
    tooLong: "النص أطول من الحد المسموح.",
    invalidPhone: "أدخل رقم جوال سعودي صحيح.",
    invalidEmail: "أدخل بريدًا إلكترونيًا صحيحًا.",
    invalidArea: "اختر مساحة من الخيارات.",
  },
  stats: {
    parking: {
      value: "300+",
      label: "موقف",
      title: "300+ موقف",
      caption: "مواقف للمستأجرين والزوار",
    },
    airport: {
      value: "المطار",
      label: "طريق",
      title: "طريق المطار",
      caption: "واجهة مباشرة على محور رئيسي",
    },
    metro: {
      value: "المترو",
      label: "قرب",
      title: "قرب المترو",
      caption: "اتصال أفضل داخل الرياض",
    },
  },
  features: {
    operational: { title: "خدمات تشغيلية", caption: "بأرقى المعايير" },
    flexible: { title: "مساحات مرنة", caption: "تناسب أعمالك" },
    prime: { title: "موقع مميز وذهبي", caption: "على طريق المطار" },
  },
  location: {
    title: "موقع استراتيجي للأعمال",
    body: "في حي قرطبة على طريق المطار، حيث سهولة الوصول إلى مناطق الأعمال والمطار، مع قرب المشروع من مسار مترو الرياض.",
    bullets: [
      "واجهة مباشرة على طريق المطار",
      "قرب مسار مترو الرياض",
      "في حي قرطبة شمال شرق الرياض",
    ],
  },
  footer: {
    developer: "المطور والمقاول",
  },
  success: {
    heading: "تم تسجيل اهتمامك بنجاح",
    message:
      "شكرًا لاهتمامك بواجهة قرطبة.\nسيتواصل معك فريقنا لتزويدك بالمساحات\nالمتاحة وتفاصيل التأجير.",
    backHome: "العودة إلى الصفحة الرئيسية",
    footerNote: "واجهة قرطبة · طريق المطار، الرياض",
  },
  a11y: {
    skipToForm: "انتقل إلى نموذج التسجيل",
    whatsapp: "تواصل مع بوند عبر واتساب",
  },
};
